import React, { useRef } from "react";
import classes from "./Overview.module.scss";
import { Card } from "react-bootstrap";
import useIsMobile from "../../../hooks/useIsMobile";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CustomImage from "../../CustomImage";

const sliderSettings = {
  dots: false,
  infinite: true,
  autoplay: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
};

const Overview = ({ countryData }: { countryData: any }) => {
  const isMobile = useIsMobile(768);
  const sliderRef = useRef<Slider>(null);
  const overviewData = countryData.overview;

  return (
    <div id="why" className={classes["overview-section-container"]}>
      <h2 className={classes["overview-title"]}>{overviewData?.title ?? "Overview"}</h2>

      <div className={classes["overview-desc"]} dangerouslySetInnerHTML={{ __html: overviewData?.description ?? "" }}></div>

      <div className={classes["overview-cards-container"]}>
        {isMobile ? (
          <div className={classes["overview-mobile-slider"]}>
            <Slider {...sliderSettings} ref={sliderRef}>
              {overviewData?.overviewCard?.length > 0 &&
                overviewData?.overviewCard?.map((card: any, index: number) => (
                  <div key={index}>
                    <Card className={classes["bootstrap-card"]}>
                      <div className={classes["icon-container"]}>
                        <CustomImage src={card.image?.url ?? "/icons/default-icon.svg"} height={72} width={72} alt="icon" />
                      </div>
                      <p className={classes["card-info"]}>{card.description ?? ""}</p>
                    </Card>
                  </div>
                ))}
            </Slider>

            <div className={classes["arrows-container"]}>
              <div className={classes["btcircle"]} onClick={() => sliderRef?.current?.slickPrev()}>
                <CustomImage src="/new-images/left-arrow.svg" height={17} width={10} alt={"left-arrow"} />
              </div>
              <div className={classes["btcircle"]} onClick={() => sliderRef?.current?.slickNext()}>
                <CustomImage src="/new-images/right-arrow.svg" height={17} width={10} alt={"right-arrow"} />
              </div>
            </div>
          </div>
        ) : (
          <div className={classes["overview-grid-layout"]}>
            {overviewData?.overviewCard?.length > 0 &&
              overviewData?.overviewCard?.map((card: any, index: number) => (
                <Card key={index} className={classes["bootstrap-card"]}>
                  <div className={classes["icon-container"]}>
                    <CustomImage src={card.image?.url ?? "/icons/default-icon.svg"} height={72} width={72} alt="icon" />
                  </div>
                  <p className={classes["card-info"]}>{card.description ?? ""}</p>
                </Card>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Overview;
